import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import RemoveIcon from '@mui/icons-material/Remove';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';

const currency = new Intl.NumberFormat('fr-MA', {
  style: 'currency',
  currency: 'MAD',
  maximumFractionDigits: 2,
});

const CartPanel = ({ items, totals, onUpdateQty, onRemove }) => (
  <div className="pos-cart-card">
    <div className="pos-cart-header">
      <div>
        <div className="pos-eyebrow">Vente en cours</div>
        <h4 className="pos-section-title">Panier</h4>
      </div>
      <div className="pos-cart-count">
        <ShoppingCartCheckoutIcon fontSize="small" />
        {items.reduce((sum, item) => sum + item.quantity, 0)}
      </div>
    </div>

    <div className="pos-cart-lines">
      {items.map((item) => (
        <div key={item.product_id} className="pos-cart-line">
          <div className="pos-cart-line-main">
            <div>
              <div className="pos-cart-line-name">{item.name}</div>
              <div className="pos-cart-line-meta">{currency.format(item.unit_price)}</div>
            </div>
            <button className="pos-icon-danger" type="button" onClick={() => onRemove(item.product_id)}>
              <DeleteOutlineIcon fontSize="small" />
            </button>
          </div>
          <div className="pos-cart-line-actions">
            <div className="pos-qty-control">
              <button type="button" onClick={() => onUpdateQty(item.product_id, Math.max(item.quantity - 1, 1))}>
                <RemoveIcon fontSize="small" />
              </button>
              <span>{item.quantity}</span>
              <button type="button" onClick={() => onUpdateQty(item.product_id, item.quantity + 1)}>
                <AddIcon fontSize="small" />
              </button>
            </div>
            <strong>{currency.format(item.unit_price * item.quantity)}</strong>
          </div>
        </div>
      ))}
      {items.length === 0 && <div className="pos-empty-state compact">Aucun article dans le panier.</div>}
    </div>

    <div className="pos-total-box">
      <div>
        <span>Sous-total</span>
        <strong>{currency.format(totals.subtotal)}</strong>
      </div>
      <div>
        <span>Remises lignes</span>
        <strong>-{currency.format(totals.lineDiscounts)}</strong>
      </div>
      <div>
        <span>Remise globale</span>
        <strong>-{currency.format(totals.globalDiscount)}</strong>
      </div>
      <div className="is-total">
        <span>Total</span>
        <strong>{currency.format(totals.total)}</strong>
      </div>
    </div>
  </div>
);

export default CartPanel;
